import React from "react";
import CheckBox from "../../../../CheckBox/CheckBox";

const ManipulativeTherapy = ({
  manipulativeTherapyData,
  setManipulativeTherapyData,
}) => {
  return (
    <div>
      <div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040]">
          <div className="h-[56px] bg-[#D9D9D9] border-b-2 rounded-t-xl border-b-solid border-b-[#8C8C8C] grid grid-cols-8">
            <div className="flex justify-center items-center">
              <CheckBox
                id="terms"
                type="heading"
                onChecked={(e) => {
                  const data = manipulativeTherapyData?.map((item) => {
                    return {
                      ...item,
                      isChecked: e,
                    };
                  });
                  setManipulativeTherapyData(data);
                }}
                isChecked={manipulativeTherapyData?.every(
                  (item) => item?.isChecked
                )}
              />
            </div>
            <div className="col-span-5 flex items-center">
              <p className="font-font-Titillium font-bold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase">
                Type
              </p>
            </div>
            <div className="col-span-2 flex items-center justify-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                Price
              </p>
            </div>
          </div>
          {manipulativeTherapyData?.map((item, index) => (
            <div className="h-[56px] border-b border-b-solid border-b-[#D9D9D9] grid grid-cols-8">
              <div className="flex justify-center items-center">
                <CheckBox
                  id="terms"
                  onChecked={(e) => {
                    const data = manipulativeTherapyData?.map((item, i) => {
                      if (i !== index) return item;
                      return {
                        ...item,
                        isChecked: e,
                      };
                    });
                    setManipulativeTherapyData(data);
                  }}
                  isChecked={manipulativeTherapyData[index]?.isChecked}
                />
              </div>
              <div className="col-span-5 flex items-center">
                <p className="font-font-Titillium font-bold text-[16px] leading-[19.2px] tracking-[0.0156em]">
                  {item?.type}
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  £{item?.price}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 h-[56px] grid grid-cols-8">
          <div className="col-span-[200px]"></div>
          <div className="col-span-5 flex items-center">
            <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-[#141414]">
              Total Charge:
            </p>
          </div>
          <div className="col-span-2 flex items-center justify-center ">
            <div className="rounded-xl bg-[#F5F5F5] w-[120px] h-[40px] flex items-center justify-center ">
              <p className="font-font-Titillium font-semibold text-[18px] leading-[27px] tracking-[0.0313] text-center">
                £
                {manipulativeTherapyData?.reduce(
                  (prev, curr) => (curr.isChecked ? prev + curr.price : prev),
                  0
                ) || 0}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManipulativeTherapy;
